import React, { useState } from 'react'
import { downloadFile, SimpleFile } from '../../../../../helpers/downloadFile'
import { TrainingProgramForm } from '../../types'
import HighlightedSearchText from './HighlightedSearchText'
import { TeamMember } from '../../../../../types'
import { getFileName } from '../../utils'

type State = 'not-started' | 'preparing' | 'done'

interface DownloadFormLinkPropTypes {
  customerNumber: string;
  getFileHandler: (customerNumber: string, fileId: number | null, fileName: string) => Promise<SimpleFile>;
  trainingProgramForm: TrainingProgramForm | null;
  searchValue: string;
  teamMember: TeamMember | null;
}

const DownloadFormLink = (props: DownloadFormLinkPropTypes) => {
  const {
    trainingProgramForm,
    teamMember,
    searchValue,
    customerNumber,
    getFileHandler,
  } = props

  const fileId = trainingProgramForm?.file_id
  const fileName = getFileName(teamMember, trainingProgramForm)

  const handleDownload = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()

    if (fileId) {
      const file = await getFileHandler(customerNumber, fileId, fileName)
      await downloadFile(file)
    }
  }
  
  return (
    <span onClick={handleDownload}>
      <HighlightedSearchText
        searchValue={searchValue}
        text={trainingProgramForm?.file_api_uploads?.display_name ?? ''}
        style={{
          fontSize: '13px',
          cursor: 'pointer',
          color:'#0086b7',
          textDecoration:'underline',
          display: 'inline-block',
          width: '100px',
          verticalAlign: 'middle'
        }}
      />
    </span>
  )
}

export default DownloadFormLink
